<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 分公司用户'}]"/>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
        <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" title="重置密码">
            <el-form :model="dataForm" :rules="dataRules" ref="dataForm" label-width="150px">
                <el-row :gutter="10" class="bg-purple xamhtrpg">
                    <el-col :span="24" >
                        <el-form-item label="新密码：" prop="du__password" :rules="{required: true, message: '密码不能为空'}" style="width: 60%">
                            <el-input v-model="dataForm.du__password" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" >
                        <el-form-item label="重复输入新密码：" prop="du__password" :rules="{required: true, message: '密码不能为空'}" style="width: 60%">
                            <el-input v-model="dataForm.password" type="password"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="tr xzmt">
                    <el-button type="primary" @click="onSubmit('dataForm')">确认提交</el-button>
                    <el-button @click="dialogVisible=false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import citysOptions from '../../utils/citys'
    export default {
        name: "BranchUserList",
        data(){
            return{
                dataForm:{
                    du__userId:'',
                    du__password:'',
                    password:'',
                },
                dataRules:{},
                dialogVisible:false,

                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '用户名',
                        field: 'du__userCode'
                    },
                    {
                        label: '姓名',
                        field: 'du__userName'
                    },
                    {
                        label: '分公司',
                        field: 'bo__branchName'
                    },
                    {
                        label: '手机号',
                        field: 'du__mobileNo'
                    },
                    {
                        label: '角色',
                        field: 'du__roles'
                    },
                    {
                        label: '状态',
                        field: 'du__disabled',
                        formatter: function (r,c,v) {
                            return   Status2CN(v)
                        }
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '编辑',
                                class: 'el-icon-edit',
                                clickHandler: (index, row)=> {
                                    this.$router.push(
                                        {
                                            path: 'edit',
                                            query: {
                                                userId: row.du__userId
                                            }
                                        }
                                    )
                                }
                            },
                            {
                                label: '重置密码',
                                class: 'el-icon-refresh',
                                clickHandler: (index, row)=> {
                                    this.dialogVisible = true
                                    this.dataForm = {
                                        du__userId:row.du__userId,
                                        du__password:'',
                                        password:'',
                                    }
                                }
                            },
                            {
                                label: '删除',
                                class: 'el-icon-delete',
                                clickHandler: (index, row)=>{
                                    this.removeItem(index, row)
                                }
                            }
                        ]
                    }
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                    {
                        label: '新增',
                        class: 'el-button--primary',
                        clickHandler: ()=>{
                            this.$router.push({
                                path: 'add'
                            })
                        }
                    }
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        du__userCode:'',
                        bo__branchId:'',
                        du__mobileNo:'',
                        du__userName:'',
                        du__roles:'',
                    },
                    columns: [

                        {
                            label: '用户名',
                            component: 'el-input',
                            field: 'du__userCode'
                        },
                        {
                            label: '分公司',
                            component: 'el-select',
                            field: 'bo__branchId',
                            options: []
                        },
                        {
                            label: '手机号',
                            component: 'el-input',
                            field: 'du__mobileNo'
                        },
                        {
                            label: '姓名',
                            component: 'el-input',
                            field: 'du__userName'
                        },
                        {
                            label: '角色',
                            component: 'el-select',
                            field: 'du__roles',
                            options: [
                                {
                                    label:'普通',
                                    value:'普通',
                                },
                                {
                                    label:'监管',
                                    value:'监管',
                                }
                            ]
                        },
                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
            this.getDataBranchOfficeSelect()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                xhr.getDataBranchUserList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },

            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.filters.columns[1].options = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },

            removeItem: function (index, row) {
                removeItem(
                    xhr.deleteBranchUser,
                    {
                        'du.userId' : row.du__userId
                    },
                    res=>{
                        try {
                            if(res.data.status == 'success') {
                                this.getData()
                            }
                        }catch (e) {

                        }
                    }
                )
            },

            onSubmit: function (formName) {
                let dataForm = this.dataForm
                this.$refs[formName].validate(valid=> {
                    if(this.dataForm.du__password==this.dataForm.password){
                        if (valid) {
                            xhr.resetBranchUserPassword(dataForm, res=> {
                                try {
                                    if (res.data.status == 'success') {
                                        this.getData()
                                        this.dialogVisible = false
                                        this.dataForm={
                                            du__userId:'',
                                            du__password:'',
                                            password:'',
                                        }
                                    }
                                } catch (e) {
                                }
                            })
                        }
                    }else {
                        this.$message.error("密码输入不一致")
                    }

                })
            },


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchUserList.vue